import { AutoCompleteModule, ComboBoxModule, DropDownListModule, MultiSelectModule } from "@progress/kendo-angular-dropdowns";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { ChartModule } from "@progress/kendo-angular-charts";
import { DialogsModule } from "@progress/kendo-angular-dialog";
import { ExpansionPanelModule, LayoutModule, PanelBarModule } from "@progress/kendo-angular-layout";
import { GridModule } from "@progress/kendo-angular-grid";
import { IconsModule } from "@progress/kendo-angular-icons";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { LabelModule } from "@progress/kendo-angular-label";
import { ListViewModule } from "@progress/kendo-angular-listview";
import { NotificationModule } from '@progress/kendo-angular-notification';
import { PopupModule } from "@progress/kendo-angular-popup";
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { TooltipsModule } from "@progress/kendo-angular-tooltip";

// Core Kendo modules that are used across the app
export const COMMON_KENDO_IMPORTS = [
    AutoCompleteModule,
    ButtonsModule,
    ChartModule,
    ComboBoxModule,
    DialogsModule,
    DropDownListModule,
    ExpansionPanelModule,
    GridModule,
    IconsModule,
    InputsModule,
    LabelModule,
    LayoutModule,
    ListViewModule,
    MultiSelectModule,
    NotificationModule,
    PanelBarModule,
    PopupModule,
    ToolBarModule,
    TooltipsModule
];
